/* ============================================================
   Klintensiv B2B — custom header + guest footer interactions
   Ported from the prototype (mega-shell.js + landing-nelogat.js
   header handlers): sticky-shadow on scroll, hover/click mega-menu,
   click-outside close, the mobile drawer, and the guest footer's
   mobile link-column accordions. Self-guards against double-init
   and re-binds on the theme editor's section:load event.
   ============================================================ */
(function(){
  'use strict';

  function initHeader(root){
    if(!root || root.dataset.klhBound) return;
    root.dataset.klhBound = '1';

    /* Sticky shadow */
    function onScroll(){
      if(window.scrollY > 12) root.classList.add('scrolled');
      else root.classList.remove('scrolled');
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    /* Mega-menu: hover opens, click toggles, click-outside closes */
    var navItems = Array.prototype.slice.call(root.querySelectorAll('.nav__item[data-mega]'));
    navItems.forEach(function(item){
      var link = item.querySelector('.nav__link');
      var closeTimer = null;
      function open(){
        clearTimeout(closeTimer);
        navItems.forEach(function(i){ if(i !== item) i.classList.remove('open'); });
        item.classList.add('open');
      }
      function close(){ closeTimer = setTimeout(function(){ item.classList.remove('open'); }, 120); }
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      if(link){
        link.addEventListener('click', function(e){
          // Only intercept when this is a pure mega trigger (no real href)
          var href = link.getAttribute('href');
          if(!href || href === '#'){
            e.preventDefault();
            if(item.classList.contains('open')) item.classList.remove('open');
            else open();
          }
        });
      }
    });
    document.addEventListener('click', function(e){
      if(!e.target.closest('.nav__item')) navItems.forEach(function(i){ i.classList.remove('open'); });
    });

    /* Mobile drawer */
    var burger = root.querySelector('.burger');
    var mobile = document.querySelector('.klh-mobile');
    if(burger && mobile){
      var closeBtn = mobile.querySelector('.klh-mobile__close');
      function openMobile(){ mobile.classList.add('open'); document.body.style.overflow = 'hidden'; }
      function closeMobile(){ mobile.classList.remove('open'); document.body.style.overflow = ''; }
      burger.addEventListener('click', openMobile);
      if(closeBtn) closeBtn.addEventListener('click', closeMobile);
      mobile.addEventListener('click', function(e){ if(e.target === mobile) closeMobile(); });
      mobile.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeMobile); });

      /* Submenu accordions */
      mobile.querySelectorAll('.m-group__toggle').forEach(function(btn){
        btn.addEventListener('click', function(){
          var group = btn.closest('.m-group');
          var isOpen = group.classList.toggle('open');
          btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      });
    }
  }

  /* Guest footer: mobile link-column accordions (.klf__col). Above 680px every
     column is expanded by CSS, so the toggle is inert there and aria-expanded
     is kept in sync with what the viewport actually shows. */
  function initFooter(root){
    if(!root || root.dataset.klfBound) return;
    root.dataset.klfBound = '1';

    var mq = window.matchMedia('(max-width:680px)');
    var cols = Array.prototype.slice.call(root.querySelectorAll('.klf__col'));

    function sync(){
      cols.forEach(function(col){
        var btn = col.querySelector('.klf__col-btn');
        if(!btn) return;
        var expanded = mq.matches ? col.classList.contains('open') : true;
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    cols.forEach(function(col){
      var btn = col.querySelector('.klf__col-btn');
      if(!btn) return;
      btn.addEventListener('click', function(){
        if(!mq.matches) return;
        col.classList.toggle('open');
        sync();
      });
    });

    if(mq.addEventListener) mq.addEventListener('change', sync);
    else if(mq.addListener) mq.addListener(sync);
    sync();
  }

  function boot(scope){
    var root = scope || document;
    root.querySelectorAll('.klh').forEach(initHeader);
    root.querySelectorAll('.klf').forEach(initFooter);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function(e){ boot(e.target || document); });
})();
